import { type Theme } from '@logto/schemas';
import { type ComponentType } from 'react';

type Props = {
  readonly className?: string;
  readonly theme: Theme;
};

// Hiraccoon downstream branding. MPL-2.0 source and notices are provided with the bundles.
const LogtoSignature: ComponentType<Props> = () => null;

export default LogtoSignature;
